export function logZodError(zodResult: { success?: boolean; error?: unknown }) {
  if (typeof zodResult?.success === 'boolean' && !zodResult.success) {
    // eslint-disable-next-line no-console
    console.error('Error of data structure mismatch', zodResult.error);
  }
}
